import { render, staticRenderFns } from "./ReportsDownload.vue?vue&type=template&id=1f458681&"
import script from "./ReportsDownload.vue?vue&type=script&lang=js&"
export * from "./ReportsDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports